function toQty(value) {
  const qty = Number(value);
  return Number.isFinite(qty) ? qty : 0;
}

function nowIso() {
  return new Date().toISOString();
}

/**
 * inventory-stock camelCase 列 → 盤點掃描已輸入列（有帳）。
 * countedQty 預設等於 systemQty（lookup）；countedAt 為加入當下 ISO。
 * 查無庫存＝404，不可加入（契約不接受無帳列）。
 */
export function mapInventoryStockToScanLine(row) {
  if (!row?.id) {
    return null;
  }

  const systemQty = toQty(row.qty?.baseQty);

  return {
    invStockId: row.id,
    inventoryStockId: row.id,
    stockNo: row.stockNo ?? '',
    mtrId: row.mtr?.id ?? '',
    mtrNo: row.mtr?.mtrNo ?? '',
    mtrName: row.mtr?.name ?? '',
    warehouseId: row.warehouse?.id ?? '',
    warehouseLabel: row.warehouse?.name || row.warehouse?.code || '',
    locationLabel: row.warehouse?.location?.name
      || row.warehouse?.location?.code
      || '',
    systemQty,
    countedQty: systemQty,
    countedAt: nowIso(),
  };
}
